module.exports = __webpack_public_path__ + "img/Group 27156.7879e2e1.svg";